import { gql } from '@/lib/graphql/gql'

export const SVL_OCI_MIGRATION_QUERY = gql`
  query SvlOciMigration($idCompany: String!) {
    svlOciMigration(idCompany: $idCompany) {
      id
      wave
      gcpClusters {
        id
        name
        displayName
        location
        provider
      }
      tcpProxyApps {
        id
        app {
          id
          name
          displayName
        }
        tcpProxies {
          id
          port
          hostname
          externalPort
          externalProxyHostname
          externalProxyPort
        }
      }
      externalDatabases {
        id
        name
        displayName
        externalHostname
        externalPort
        isExternalProxyEnabled
        externalProxyHostname
        externalProxyPort
      }
    }
  }
`

export const COMPANY_MIGRATION_SCHEDULE_QUERY = gql`
  query CompanyClusterMigrationSchedule($idCompany: String!) {
    companyClusterMigrationSchedule(idCompany: $idCompany) {
      id
      idCompany
      wave
      status
      scheduledAt
      reason
      canReschedule
      targetClusters {
        id
        name
        displayName
        location
        provider
      }
      notes {
        id
        idUser
        content
        createdAt
      }
    }
  }
`

export const COMPANY_MIGRATION_SLOTS_QUERY = gql`
  query CompanyClusterMigrationScheduleSlots($idCompany: String!, $limit: Int) {
    companyClusterMigrationScheduleSlots(idCompany: $idCompany, limit: $limit)
  }
`

export const RESCHEDULE_MIGRATION_MUTATION = gql`
  mutation RescheduleClusterMigration(
    $idCompany: String!
    $scheduledAt: Date!
    $note: String
  ) {
    rescheduleClusterMigration(
      idCompany: $idCompany
      scheduledAt: $scheduledAt
      note: $note
    )
  }
`

export const ADD_MIGRATION_NOTE_MUTATION = gql`
  mutation AddClusterMigrationScheduleNote(
    $idCompany: String!
    $content: String!
  ) {
    addClusterMigrationScheduleNote(idCompany: $idCompany, content: $content)
  }
`

export const DELETE_MIGRATION_NOTE_MUTATION = gql`
  mutation DeleteClusterMigrationScheduleNote(
    $idCompany: String!
    $id: String!
  ) {
    deleteClusterMigrationScheduleNote(idCompany: $idCompany, id: $id)
  }
`
